<template>
  <div class="px-1 py-1">
    <div class="flex pb-2 items-center">
      <div>
        <BreadCrumb :bread-crumbs-data="breadCrumbsData" />
      </div>
    </div>
    <div v-if="title" class="flex flex-col w-11/12 pt-1">
      <div
        class="text-base sm:text-title flex text-primary font-semibold text-center font-inter text-[28px] leading-none tracking-normal"
      >
        <template v-if="memberName">
          <router-link
            v-if="memberBasicInfoRoute"
            :to="memberBasicInfoRoute"
            class="text-primary hover:underline cursor-pointer"
          >
            {{ memberName }}
          </router-link>
          <span v-else>
            {{ memberName }}
          </span>
          <span v-if="title">&nbsp;{{ title }}</span>
        </template>
        <span v-else>{{ title }}</span>
      </div>
      <!-- 
      <div v-if="info" class="flex item-center pt-3">
        <p class="text-center text-sm font-inter text-[16px] leading-none tracking-normal">
          {{ info }}
        </p>
      </div> -->
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'

import BreadCrumb from './Header/BreadCrumb.vue'

export default {
  name: 'SwdSubHeader',
  components: {
    BreadCrumb,
  },
  props: {
    title: {
      type: String,
      required: true,
      default: '',
    },
    info: {
      type: String,
      required: false,
      default: '',
    },
    breadCrumbsData: {
      type: Array,
      required: false,
      default: () => [],
    },
    memberName: {
      type: String,
      required: false,
      default: '',
    },
    memberBasicInfoRoute: {
      type: [Object, String],
      required: false,
      default: null,
    },
  },
  setup(props) {
    const router = useRouter()

    const back = () => {
      router.push({ name: props.backPage })
    }

    return {
      back,
    }
  },
}
</script>
